import {YoutubePlayer as YTP} from "./YoutubePlayer";
import PlayerState from "./PlayerState";

export class HashValue {
    mediaID = null;
    playerType = null;
    loops: any[] = [];
}
export default  class HashDAO {

    static getHashValues(paramsStr = null): HashValue {
        let params = paramsStr || window.location.hash.substring(1);
        let result = {}
        if (params && params !== '') {
            result = params.split('&').reduce(function (res, item) {
                const parts = item.split('=');
                res[parts[0]] = parts[1];
                return res;
            }, {});
        }
        let hv = new HashValue()
        for (let prop in hv) {
            if (Object.prototype.hasOwnProperty.call(hv, prop)) {
                if(result[prop] !== undefined && result[prop] !== null && result[prop] !== '') {
                    if (prop === "loops") {
                        hv[prop] = JSON.parse(atob(result[prop]))
                    } else {
                        hv[prop] = result[prop]
                    }
                }

            }
        }
        return hv;
    }

    static generateHashValues(val: HashValue){
        let hash = ""
        if (val.playerType != null && val.mediaID != null) {
            hash += "playerType=" + val.playerType + "&" + "mediaID=" + val.mediaID

            if (val.loops.length > 0) {
                let j = JSON.stringify(val.loops);
                let encodedData = btoa(j);
                hash += "&loops=" + encodedData;
            }

        }
        return hash
    }

    static generateHashFromState(state: PlayerState):string{
        let hv = new HashValue()
        hv.playerType = state.playerType
        hv.mediaID  =  state.mediaId
        hv.loops = state.loops || []
        return this.generateHashValues(hv);

    }


};